import { render } from "./gameRate.vue?vue&type=template&id=cb4b1034&scoped=true"
import script from "./gameRate.vue?vue&type=script&lang=js"
export * from "./gameRate.vue?vue&type=script&lang=js"

import "./gameRate.vue?vue&type=style&index=0&id=cb4b1034&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4b1034"]])

export default __exports__